export default __webpack_public_path__ + "static/media/rewards_logo.0764f0f1.svg";